import React, { useEffect, useState } from "react";
import axios from "axios";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import {
  Grid,
  Card,
  CircularProgress,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  OutlinedInput,
  Snackbar,
} from "@mui/material";

// @mui icons
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

function SocialMedia() {
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [filterType, setFilterType] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteBox, setdeleteBox] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    url: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  const userRole = localStorage.getItem("userRole");
  const sessionToken = localStorage.getItem("sessionToken");
  const API_BASE_URL = "https://api.exampladmedia.com/social-media";

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/getAllMedia/all`, {
        headers: { Authorization: sessionToken },
      });
      const apiData = response.data || [];
      setAllData(apiData);
      renderTable(apiData);
    } catch (error) {
      showSnackbar("Error fetching social media platforms.");
    } finally {
      setLoading(false);
    }
  };

  const showSnackbar = (msg) => {
    setSnackbarMsg(msg);
    setOpenSnackbar(true);
  };

  const handleOpenModal = (item = null) => {
    if (item) {
      setIsEditMode(true);
      setSelectedItem(item);
      setFormData({ name: item.name, url: item.url });
    } else {
      setIsEditMode(false);
      setFormData({ name: "", url: "" });
    }
    setModalOpen(true);
  };

  const handleSave = async () => {
    try {
      const id = selectedItem?.id;
      const url = isEditMode
        ? `${API_BASE_URL}/editMedia/${id}`
        : `${API_BASE_URL}/createMedia`;

      const method = isEditMode ? "put" : "post";

      const response = await axios[method](url, formData, {
        headers: { Authorization: sessionToken },
      });

      if (response.status === 200 || response.status === 201) {
        showSnackbar(isEditMode ? "Platform updated successfully!" : "Platform created successfully!");
        setModalOpen(false);
        fetchData();
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Failed to save changes.";
      showSnackbar(errorMsg);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/removeMedia/${selectedItem.id}`,
        {
          headers: { Authorization: sessionToken },
        }
      );

      if (response.status === 200) {
        showSnackbar("Platform removed successfully!");
        fetchData();
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Error removing platform.";
      showSnackbar(errorMsg);
    } finally {
      setdeleteBox(false);
    }
  };

  const renderTable = (data) => {
    const rows = data
      .filter((item) => !filterType || item.name.toLowerCase().includes(filterType.toLowerCase()))
      .map((item, index) => ({
        srNo: index + 1,
        name: item.name,
        url: item.url || "N/A",
        actions: (
          <MDBox display="flex" justifyContent="center" gap={1}>
            <IconButton color="info" size="small" onClick={() => handleOpenModal(item)}>
              <EditIcon style={{ color: "green" }} />
            </IconButton>
            {userRole === "SUPER_ADMIN" && (
              <IconButton color="secondary" size="small" onClick={() => {
                setSelectedItem(item);
                setdeleteBox(true);
              }}>
                <DeleteIcon style={{ color: "red" }} />
              </IconButton>
            )}
          </MDBox>
        ),
      }));

    setTableData({
      columns: [
        { Header: "Sr. No", accessor: "srNo", align: "center" },
        { Header: "Platform", accessor: "name", align: "center" },
        // { Header: "URL", accessor: "url", align: "left" },
        { Header: "Actions", accessor: "actions", align: "center" },
      ],
      rows,
    });
  };

  useEffect(() => {
    renderTable(allData);
  }, [filterType, allData]);

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2} mt={-3} py={3} px={2}
            variant="gradient" bgColor="info" borderRadius="lg"
            display="flex" justifyContent="space-between" alignItems="center"
          >
            <Button
              variant="contained"
              onClick={() => handleOpenModal()}
              style={{ backgroundColor: "white", color: "#111" }}
            >
              Add Media
            </Button>
            <h2 style={{ color: "white", margin: 0, fontSize: '1.5rem' }}>Social Media Management</h2>
            <MDBox backgroundColor="white" borderRadius="8px" px={1}>
              <OutlinedInput
                size="small"
                placeholder="Search..."
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                sx={{
                  height: "40px",
                  color: "#fff",
                  "& input::placeholder": {
                    color: "#fff",
                    opacity: 1, // important (warna light grey dikhega)
                  },
                }}
              />
            </MDBox>
          </MDBox>

          <MDBox pt={3}>
            {loading ? (
              <MDBox display="flex" justifyContent="center" p={5}><CircularProgress color="info" /></MDBox>
            ) : (
              <DataTable table={tableData} isSorted={false} entriesPerPage={false} showTotalEntries={false} noEndBorder />
            )}
          </MDBox>
        </Card>
      </MDBox>

      {/* ADD / EDIT MODAL */}
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>{isEditMode ? "Edit Social Media" : "Add Social Media"}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth label="Platform Name" margin="normal" value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value.toUpperCase() })}
          />
          {/* <TextField
            fullWidth label="URL" margin="normal" value={formData.url}
            onChange={(e) => setFormData({ ...formData, url: e.target.value })}
          /> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} color="info" variant="contained">Save</Button>
        </DialogActions>
      </Dialog>

      {/* DELETE DIALOG */}
      <Dialog open={deleteBox} onClose={() => setdeleteBox(false)}>
        <DialogTitle>Confirm Removal</DialogTitle>
        <DialogContent>
          <p>Remove <b>{selectedItem?.name}</b>?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setdeleteBox(false)}>Cancel</Button>
          <Button onClick={handleDelete} style={{ color: "red" }}>Remove</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        message={snackbarMsg}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </DashboardLayout>
  );
}

export default SocialMedia;